// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Xf+jl","employee-header-item":"Header_employee-header-item__dh2P+"};